import { render, staticRenderFns } from "./encourage.vue?vue&type=template&id=1267ad1a&scoped=true"
import script from "./encourage.vue?vue&type=script&lang=js"
export * from "./encourage.vue?vue&type=script&lang=js"
import style0 from "./encourage.vue?vue&type=style&index=0&id=1267ad1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267ad1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1267ad1a')) {
      api.createRecord('1267ad1a', component.options)
    } else {
      api.reload('1267ad1a', component.options)
    }
    module.hot.accept("./encourage.vue?vue&type=template&id=1267ad1a&scoped=true", function () {
      api.rerender('1267ad1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/encourage.vue"
export default component.exports